import script from "./ProductionChart.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductionChart.vue?vue&type=script&setup=true&lang=js"

import "./ProductionChart.vue?vue&type=style&index=0&id=03b605f4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Simeon\\Desktop\\asic-webpack\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03b605f4"]])

export default __exports__